import apiService from '../../../services/api';
import { LegalModel } from '../model/legalModel';

export const legalApi = {
  async fetchContent(type: 'privacy' | 'terms'): Promise<LegalModel> {
    const endpoint = type === 'privacy' 
      ? 'system-settings/public/privacy_content'
      : 'system-settings/public/terms_content';
    
    const response = await apiService.get(endpoint);
    return LegalModel.fromJSON(response.data);
  }
};
